<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/ffutOW/tc-custom/9781528965644.jpg?1705687990365" alt="This image is the cover for the book The Luggage Lifter"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Luggage Lifter
      </h1>
      <p class="bookDescription body article font2">
        <p>Meet Harold, a young man who occupies a room in a bleak tenement in the edgy Blitz-damaged East End. Harold’s good humour and air of optimism belie the unfortunate circumstances which blighted his childhood, left him orphaned and shaped his view of the world. An intelligent, resourceful and amiable character, operating around the London hotels and railway stations, he turns luggage lifting into an art form. When he discovers a stash of letters in a leather steamer, an act of kindness sets off a chain of events which gathers its own momentum and leads to romance. But the escalation in his criminal activities, together with the finding of a large haul of used banknotes can only spell trouble. The attention of the police and the menace of the Moretti brothers, who claim the money, coincide, and arrest seems a safer outcome for Harold. He survives a prison term but soon learns that shaking off his unresolved past is more difficult, especially when trying to do the right thing leads to complications in his love life. Just when a sense of well-being beckons, matters spiral out of control and push Harold to the brink…</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Terence Connor
      </h2>
      
      <p class="authorDescription body article">Terence Connor was born in Whitechapel and has always lived in London, apart from attendance at universities and periods working abroad in Spain (film extra English classes in a language school, and private tutor to a bullfighter) and in Ecuador (volunteer in a shanty town). He has studied at the universities of Newcastle-upon-Tyne, Kent and LSE, worked in social services departments and in a voluntary child care and adoption agency. More recently, he has obtained a masters in creative writing with distinction from Exeter University. This is his first novel.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5ab49914